import React from 'react'
import classNames from 'classnames'
import { CaptionSM } from '@/atoms/Text'
import { useAngelPlayerContext } from '@/organisms/AngelPlayer'
import { CollectibleSceneInfo } from '@/organisms/CollectibleSceneInfo'
import { StoryListPanel } from '@/organisms/CollectibleSceneInfo/StoriesListPanel'
import { useCollectiblesPlayerEngagement } from '@/organisms/CollectiblesPlayer/CollectiblesPlayerEngagement/CollectiblesPlayerEngagementContext'
import { useTranslate } from '@/utils/translate/translate-client'

export const CollectiblesPlayerEngagementOverlay = React.memo(() => {
  const { isEngagementPanelOpen, engagementPanelState } = useCollectiblesPlayerEngagement()
  const { showCommunityView, toggleCommunityViewOff } = useAngelPlayerContext()
  const { t } = useTranslate('watch')

  if (!showCommunityView) return null

  return (
    <div
      className={classNames(
        'z-1 absolute transition-all duration-300 ease-in-out max-w-md hidden right-4 top-10 md:block flex-none mt-10 h-fit',
        { 'transition-all duration-300 ease-in-out hidden md:block -left-1/3': !isEngagementPanelOpen },
      )}
      id="engagement-overlay"
    >
      {engagementPanelState === 'stories-list' && (
        <div className="inset-0 flex-1 overflow-y-auto overflow-x-hidden rounded-xl bg-black/60 backdrop-blur-2xl sm:absolute">
          <StoryListPanel hideMomentFullscreen />
        </div>
      )}
      {engagementPanelState === 'collectible-scene' && (
        <div className="relative w-full rounded-xl bg-black/70 pt-10">
          <div
            className="absolute right-4 top-2 flex w-fit cursor-pointer items-center justify-center rounded-full bg-black/70 px-2 py-1"
            onClick={() => toggleCommunityViewOff()}
          >
            <CaptionSM color="core-gray-400">{t('close', 'Close')}</CaptionSM>
          </div>
          <CollectibleSceneInfo hideMomentFullscreen />
        </div>
      )}
    </div>
  )
})

CollectiblesPlayerEngagementOverlay.displayName = 'React.memo(CollectiblesPlayerEngagementPanel)'
